import React from 'react';
import { ErrorBoundary } from './ErrorBoundary';
import styles from '@/styles/components/ComingSoonPage.module.css';

export interface ComingSoonPageProps {
  /** Title of the feature that's coming soon */
  title: string;
  /** Description of what the feature will offer */
  description: string;
  /** Icon to display (can be emoji, SVG path, or component) */
  icon?: React.ReactNode;
  /** Custom CSS class name */
  className?: string;
}

/**
 * Coming Soon Page Component
 * Displays a placeholder page for features that are under development
 * 
 * @example
 * ```tsx
 * <ComingSoonPage
 *   title="Advanced Analytics"
 *   description="Get detailed insights into your AI model performance"
 *   icon="📊"
 * />
 * ```
 */
const ComingSoonPage: React.FC<ComingSoonPageProps> = ({
  title,
  description,
  icon = '🚀',
  className,
}) => {




  return (
    <ErrorBoundary>
      <div className={`${styles.container} ${className || ''}`}>


        {/* Main Content */}
        <main className={styles.main} role="main">
          <div className={styles.content}>
            {/* Icon */}
            <div className={styles.iconContainer}>
              {typeof icon === 'string' ? (
                <span className={styles.iconEmoji} role="img" aria-label="Feature icon">
                  {icon}
                </span>
              ) : (
                <div className={styles.iconCustom}>
                  {icon}
                </div>
              )}
            </div>

            {/* Title */}
            <h1 className={styles.title} id="page-title">
              {title}
            </h1>

            {/* Description */}
            <p className={styles.description}>
              {description}
            </p>


          </div>
        </main>


      </div>
    </ErrorBoundary>
  );
};

ComingSoonPage.displayName = 'ComingSoonPage';

export default ComingSoonPage;
